
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 770 1310 270","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"SVGID_1_","gradientUnits":"userSpaceOnUse","x1":"8","y1":"134.5","x2":"1302","y2":"134.5","gradientTransform":"matrix(1 0 0 -1 0 1080)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#fb0fc6"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#d82842"}})]),_c('path',{attrs:{"fill":"url(#SVGID_1_)","d":"M58 871h1244l-52 149H8z"}}),_c('linearGradient',{attrs:{"id":"SVGID_00000180355157394132795130000011867132722613702824_","gradientUnits":"userSpaceOnUse","x1":"20","y1":"250.5","x2":"701","y2":"250.5","gradientTransform":"matrix(1 0 0 -1 0 1080)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#c3eb11"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#c3eb11"}})]),_c('path',{attrs:{"fill":"url(#SVGID_00000180355157394132795130000011867132722613702824_)","d":"M701 788H48l-28 83h654z"}}),_c('linearGradient',{attrs:{"id":"SVGID_00000028303052500989672240000011789189457453040272_","gradientUnits":"userSpaceOnUse","x1":"20","y1":"176.5","x2":"58","y2":"176.5","gradientTransform":"matrix(1 0 0 -1 0 1080)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#7d901b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#7d901b"}})]),_c('path',{attrs:{"fill":"url(#SVGID_00000028303052500989672240000011789189457453040272_)","d":"M20 872h38l-19 63z"}})])
          )
        }
      }
    